import { useLocation } from 'react-router-dom';
import "./ErrorPage.css";

const ErrorPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const errorType = params.get('errorType');

  // エラータイプに応じたメッセージを設定
  const getErrorMessage = () => {
    switch (errorType) {
      case 'referrer':
        return {
          title: 'アクセスが許可されていません',
          message: 'このページからのアクセスは許可されていません。正しいURLからアクセスしてください。'
        };
      case 'campaign_inactive':
        return {
          title: '契約期間が終了しています',
          message: 'このプランはご契約いただけません。'
        };
      default:
        return {
          title: '契約期間が終了しています',
          message: 'このプランはご契約いただけません。'
        };
    }
  };

  const error = getErrorMessage();

  return (
    <div className="error-container">
      <div className="error-card">
      <div className="error-icon">⚠</div>
      <h1 className="error-title">{error.title}</h1>
      <p className="error-message">{error.message}</p>
      </div>
    </div>
  );
};

export default ErrorPage;
